<template>
  <span
    v-if="disableTransitions"
    :class="containerKls"
    :style="wrapperStyle"
    @click="handleClick"
  >
    <span :class="ns.e('content')">
      <slot />
    </span>
    <jd-icon v-if="closable" :class="ns.e('close')" @click.stop="handleClose">
      <Close />
    </jd-icon>
  </span>
  <transition v-else :name="`${ns.namespace.value}-zoom-in-center`" appear>
    <span
      :class="containerKls"
      :style="wrapperStyle"
      @click="handleClick"
    >
      <span :class="ns.e('content')">
        <slot />
      </span>
      <jd-icon v-if="closable" :class="ns.e('close')" @click.stop="handleClose">
        <Close />
      </jd-icon>
    </span>
  </transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import JdIcon from '@jdesign-vue/components/icon'
import { Close } from '@jd/jdesign-icons-vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { useFormSize } from '@jdesign-vue/components/form'

import { tagEmits, tagProps } from './tag'

defineOptions({
  name: 'JdTag',
})
const props = defineProps(tagProps)
const emit = defineEmits(tagEmits)

const tagSize = useFormSize()
const ns = useNamespace('tag')
const containerKls = computed(() => {
  const { type, hit, effect, closable, round } = props
  return [
    ns.b(),
    ns.is('closable', closable),
    ns.m(type),
    ns.m(tagSize.value),
    ns.m(effect),
    ns.is('hit', hit),
    ns.is('round', round),
  ]
})

const wrapperStyle = computed(() => {
  const { color, textColor, borderColor } = props
  return {
    backgroundColor: color,
    color: textColor,
    borderColor,
  }
})

// methods
const handleClose = (event: MouseEvent) => {
  emit('close', event)
}

const handleClick = (event: MouseEvent) => {
  emit('click', event)
}
</script>
